import styled from '@emotion/styled';
import { MenuButton, MenuButtonProps, blue, grey, red } from '@galaxy-react/core';
import React from 'react';
import Typography from '../Typography';

const MenuButtonStyledInner = styled(MenuButton)({
  color: grey[600],
  '--colorNeutralBackground1Selected': '#fff',
  '--colorNeutralForeground2BrandSelected': grey[600],
  '--colorNeutralForeground2BrandPressed': grey[600],
  '&.fui-Button': {
    gap: 0,
  },
  '& .fui-MenuButton__menuIcon': {
    height: 16,
    width: 16,
    color: blue[700],
  },
  '&.error': {
    svg: {
      color: red[500],
    },
  },
});
type IProps = MenuButtonProps & {
  placeholder?: string;
};

const MenuButtonStyled = ({ children, placeholder, ...props }: IProps, ref) => {
  return (
    <MenuButtonStyledInner ref={ref} {...props} autoFocus={false}>
      {!!children && children}
      {!children && placeholder && <Typography type="secondary">{placeholder}</Typography>}
    </MenuButtonStyledInner>
  );
};

export default React.forwardRef(MenuButtonStyled);
